<template>
    <div>
        <div v-if="!editTimezone" class="alert alert-secondary">
            {{ $t('watches.timezone.info') }}
            <button type="button" class="btn btn-light btn-sm font-weight-bold" @click="handleShowEditor">
                {{ selected }}
                <i class="pl-2 fa fa-pencil btn-icon"></i>
            </button>
        </div>
        <div v-if="editTimezone" class="alert alert-warning d-flex flex-column">
          <div class="mb-2">{{ $t('watches.timezone.warning') }}</div>
          <TimezonePicker class="mb-2" v-model="selected" />
          <div class="mb-2 d-flex flex-row">
            <Button2 class="btn-sm btn-brand" @click.native.prevent="handleConfirmTimezone">
                <i class="fa fa-check" aria-hidden="true" :aria-title="$t('watches.timezone.confirm')"></i>
            </Button2>
            <Button2 class="mx-2 btn-sm btn-danger" @click.native.prevent="handleCancelTimezone">
                <i class="fa fa-close" aria-hidden="true" :aria-title="$t('watches.timezone.cancel')"></i>
            </Button2>
          </div>
        </div>
    </div>
</template>

<script>
import TimezonePicker from '@/components/ui/datetime/TimezonePicker';
import Button2 from '@/components/ui/Button2';

export default {
    name: "TimezoneEditor",
    components: {
        TimezonePicker,
        Button2
    },
    props: {
        value: {
            type: String
        }
    },
    data: () => ({
        selected: null,
        editTimezone: false,
    }),
    created: function() {
        this.selected = this.value;
    },
    methods: {
        handleShowEditor: function () {
            this.editTimezone = true;
        },
        handleConfirmTimezone: function () {
            this.$emit('input', this.selected);
            this.editTimezone = false;
        },
        handleCancelTimezone: function () {
            this.editTimezone = false;
            this.selected = this.value;
        },
    },
    watch: {
        value: function(newVal) {
            this.selected = newVal;
        }
    }
}
</script>

<style lang="scss" scoped>
.btn-icon:hover {
    cursor: pointer;
}
</style>
